import i18n from "../../../i18n"

export const professors =
{
    department: i18n.t("esp_department"),

    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1792/9478-grayscale-300x300xc-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('papadopoulos'),
                title: i18n.t('proedrosTmimatos'),
                tel: '2310 891.389',
                email: 'kpapado@uom.edu.gr',
                building: 'ΚΖ',
                office: '306'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('Anthony Jude'),
                lname: i18n.t('Montgomery'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.308',
                email: 'antmont@uom.edu.gr',
                building: 'ΚΖ',
                office: '208'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('agaliotis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.383',
                email: 'iagal@uom.edu.gr',
                building: 'ΚΖ3',
                office: '301A'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1791/2000-valkanosE-2.jpg',
                fname: 'euthimios',
                lname: 'valkanos',
                title: 'kathigitis',
                tel: '2310 891.385',
                email: 'evalkan@uom.edu.gr',
                building: 'ΚΖ3',
                office: '303'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1785/9481-Okalidou1-2.jpg',
                fname: 'areti',
                lname: 'okalidou',
                title: 'kathigitria',
                tel: '2310 891.358',
                email: 'okalidou@uom.edu.gr',
                building: 'ΚΖ',
                office: '307'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1779/1209-platsidu-2.jpg',
                fname: 'maria',
                lname: 'platsidou',
                title: 'kathigitria',
                tel: '2310 891.384',
                email: 'platsidou@uom.edu.gr',
                building: 'ΚΖ3',
                office: '308'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('anastasia'),
                lname: i18n.t('psalti'),
                title: i18n.t('kathigitria'),
                tel: '2310 891.863',
                email: 'psalti.an@uom.edu.gr',
                building: '',
                office: ''
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1802/10488-Eirini_Gouleta-2.jpg',
                fname: i18n.t('eirini'),
                lname: i18n.t('gouleta'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.848',
                email: 'egouleta@uom.edu.gr',
                building: 'ΓΔ',
                office: '331'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1787/2096-KartasidouL-2.jpg',
                fname: i18n.t('leukothea'),
                lname: i18n.t('kartasidou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.350',
                email: 'lefka@uom.edu.gr',
                building: 'KZ2',
                office: '202'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('eleni'),
                lname: i18n.t('koustriava'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.333',
                email: 'elkous@uom.edu.gr',
                building: 'KZ3',
                office: '316'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1790/1192-ipapav-2.jpg',
                fname: i18n.t('ioanna'),
                lname: i18n.t('papavasileiou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.524',
                email: 'ipapav@uom.edu.gr',
                building: 'KZ',
                office: '311'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1801/9468-photo_PAPAKONSTANTINOU_small-2.jpg',
                fname: i18n.t('doxa'),
                lname: i18n.t('papakonstantinou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.403',
                email: 'klerip@uom.edu.gr',
                building: 'ΚΖ',
                office: '315'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1799/1188-hproios-2.jpg',
                fname: i18n.t('harikleia'),
                lname: i18n.t('proiou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.630',
                email: 'hproios@uom.edu.gr',
                building: 'ΚΖ',
                office: '315'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1789/4597-staboulis-2.png',
                fname: i18n.t('miltiadis'),
                lname: i18n.t('stampoulis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.621',
                email: 'staboulis@uom.edu.gr',
                building: 'ΚΖ',
                office: '427'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1796/3042-Syriopoulou_ed-2.jpg',
                fname: i18n.t('christina'),
                lname: i18n.t('syriopoulou_delli'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.381',
                email: 'csyriop@uom.edu.gr',
                building: 'ΚΖ',
                office: '310'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1797/10256-Fachantidis_340X340_-2.jpg',
                fname: i18n.t('nikolaos'),
                lname: i18n.t('fahantidis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.483',
                email: 'nfachantidis@uom.edu.gr',
                building: 'ΚΖ',
                office: '302'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1809/1698-varsamis-2.jpg',
                fname: i18n.t('panagiotis'),
                lname: i18n.t('varsamis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.360',
                email: 'varsamis@uom.edu.gr',
                building: 'ΚΖ',
                office: '205'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1798/9538-IMG_20210311_100705-2.jpg',
                fname: i18n.t('vasiliki'),
                lname: i18n.t('giannouli'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.335',
                email: 'giannouli@uom.edu.gr',
                building: 'ΚΖ',
                office: '301'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: i18n.t('maria'),
                lname: i18n.t('sitziouki'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.771',
                email: 'sitziouki@uom.edu.gr',
                building: 'ΚΖ',
                office: '305'
            }
        ]
}